import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const links = [
  { label: "Approach", href: "#approach" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="h-2.5 w-2.5 bg-primary block rotate-45 group-hover:rotate-[135deg] transition-transform duration-500" />
          <span className="font-display font-black text-lg tracking-tight uppercase">
            Fuze<span className="text-primary">Point</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-foreground/70 hover:text-primary transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta"
          className="group relative inline-flex items-center gap-2 border border-primary px-5 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-primary overflow-hidden"
        >
          <span className="absolute inset-0 bg-primary translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
          <span className="relative group-hover:text-white transition-colors duration-300">
            Start Your Journey
          </span>
        </a>
      </div>
    </motion.header>
  );
}
